<template>
  <div class="thirdPage">
    <div class="tagBox" v-show="aiModel===2">
      <el-button
          v-for="(product, index) in productList"
          :key="product.productId"
          :type="form.productId===product.productId?'primary': ''"
          @click="tagClick(product,index)"
          :disabled="canChangeProduct"
          size="mini"
      >
        {{ product.title }}
      </el-button>
      <el-button
          v-for="(productType, index) in productTypeList"
          :key="productType.productTypeId"
          :type="form.productTypeId===productType.productTypeId?'primary': ''"
          @click="tagClick(productType,index)"
          :disabled="canChangeProduct"
          size="mini"
      >
        {{ productType.title }}
      </el-button>
    </div>
    <div class="formBox">
      <el-form ref="thirdForm" :model="form" label-position="top">
        <el-row>
          <el-col :span="8">
            <el-form-item prop="aiKeywordList" label="产品核心关键词">
              <el-input :style="formItemStyle" type="textarea" :autosize="true" v-model="aiKeyword"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="aiDesc" label="产品描述">
              <el-input :style="formItemStyle" type="textarea" :autosize="true" v-model="form.aiDesc"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="补充说明">
              <el-input :style="formItemStyle" type="textarea" v-model="form.aiIllustrate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="产品网址">
              <el-input :style="formItemStyle" v-model="form.pagePath"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="输出语言">
              <el-select :style="formItemStyle" v-model="form.aiLanguage" :clearable="false"
                         placeholder="请选择" :filterable="true">
                <el-option v-for="item in languageList" :key="item.criterionId" :label="item.languageNameZh"
                           :value="item.criterionId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="使用语气">
              <el-select :style="formItemStyle" v-model="form.aiToneType" :clearable="false"
                         placeholder="请选择">
                <el-option label="正式" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="产品优势">
              <el-select :style="formItemStyle" v-model="form.productAdvantageList" :multiple="true"
                         placeholder="请选择">
                <el-option v-for="item in extraData.descProductAdvantageList" :key="item.id"
                           :label="item.content + ' - ' + item.enContent" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="服务优势">
              <el-select :style="formItemStyle" v-model="form.serviceAdvantageList" :multiple="true"
                         placeholder="请选择">
                <el-option v-for="item in extraData.descServiceAdvantageList" :key="item.id"
                           :label="item.content + ' - ' + item.enContent" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="促销语">
              <el-select :style="formItemStyle" v-model="form.salesSlogansList" :multiple="true"
                         placeholder="请选择">
                <el-option v-for="item in extraData.descPromotionList" :key="item.id"
                           :label="item.content + ' - ' + item.enContent" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工厂优势">
              <el-select :style="formItemStyle" v-model="form.factoryAdvantageList" :multiple="true"
                         placeholder="请选择">
                <el-option v-for="item in extraData.descFactoryAdvantageList" :key="item.id"
                           :label="item.content + ' - ' + item.enContent" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="号召性用语">
              <el-select :style="formItemStyle" v-model="form.callOutList" :multiple="true" placeholder="请选择">
                <el-option v-for="item in extraData.descCalloutList" :key="item.id"
                           :label="item.content + ' - ' + item.enContent" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <keyword-card
        v-if="form.aiKeywordFlag"
        :keywordLoading="keywordLoading"
        :keywordList="keywordList"
        :programmeDetailId="form.programmeDetailId"
        @modify="aiModify"
        @del="delKeyword"
        @clear="clearKeyword"
        @remake="remakeKeyword"
        @addGoogleKey="addGoogleKey"
        @getImg="getKeywordImage"
        @fillTo="fillKeyword"
    ></keyword-card>
    <title-card
        v-if="form.aiTitleFlag"
        :titleLoading="titleLoading"
        :titleList="titleList"
        :programmeDetailId="form.programmeDetailId"
        @modify="aiModifyTitle"
        @clear="clearTitle"
        @del="delTitle"
        @remake="remakeTitle"
        @fillTo="fillTitle"
    ></title-card>
    <describe-card
        v-if="form.aiDescFlag"
        :descLoading="descLoading"
        :descList="descList"
        :programmeDetailId="form.programmeDetailId"
        @modify="aiModifyDesc"
        @clear="clearDesc"
        @del="delDesc"
        @remake="remakeDesc"
        @fillTo="fillDesc"
    ></describe-card>
  </div>
</template>
<script>
import keywordCard from "@/components/aiAds/components/keywordCard.vue";
import titleCard from "@/components/aiAds/components/titleCard.vue";
import describeCard from "@/components/aiAds/components/describeCard.vue";
import {mapState} from 'vuex';
import adsNewOnlineSer from "@/backend/services/adsNewOnline/adsNewOnlineSer";
import sem from "@/backend/services/sem/sem";

export default {
  name: 'thirdPage',
  components: {
    keywordCard,
    titleCard,
    describeCard
  },
  computed: {
    ...mapState({
      aiModel: state => state.aiAds.aiModel,
      currentInfo: state => state.aiAds.currentInfo
    }),
    canChangeProduct() {
      return this.keywordLoading || this.titleLoading || this.descLoading;
    }
  },
  data() {
    return {
      form: {
        "aiDesc": "",
        "aiIllustrate": "",
        "aiKeywordList": [],
        "aiLanguage": 1000,
        "aiToneType": 1,
        "callOutList": [],
        "factoryAdvantageList": [],
        "pagePath": "",
        "productAdvantageList": [],
        "salesSlogansList": [],
        "serviceAdvantageList": [],
      },
      formItemStyle: {
        width: '80%'
      },
      extraData: {
        descCalloutList: [], //号召性用语集合
        descFactoryAdvantageList: [], // 工厂优势集合
        descProductAdvantageList: [], // 产品优势集合
        descPromotionList: [],// 促销语集合
        descServiceAdvantageList: [], // 服务优势集合
      },
      languageList: [],// 语言列表
      productList: [],// 产品
      productTypeList: [],// 产品分类
      aiKeyword: '', // 产品关键词
      // 关键词卡片
      keywordLoading: false,
      keywordList: [],
      automationId: '', // 自动化上线主id
      // 广告标题卡片
      titleLoading: false,
      titleList: [],
      // 广告描述卡片
      descLoading: false,
      descList: []
    }
  },
  watch: {
    aiKeyword: {
      handler(val) {
        if (val) {
          // 关键词输入时，转换为字符串数组，去重、去掉空字符串元素
          this.form.aiKeywordList = [...new Set(val.split('\n'))].filter(item => item !== "");
        }
      }
    },
  },
  mounted() {
    // 请求高级信息
    this.getMontageContent(2);
    // 请求语言
    this.adLanguage();
    // 请求产品信息
    let param = {
      customerId: this.currentInfo.customerId,
      programmeId: this.currentInfo.programmeId,
      serviceId: this.currentInfo.serviceId
    }
    this.getProductList(param);
  },
  methods: {

    // 修改基础信息接口
    async editProductInfo() {
      await sem.addSingleProduct(this.form)
    },
    /***
     * 关键词处理 --- 开始
     */
    // 请求关键词生成记录
    async getKeywordTemp() {
      let res = await sem.getKeywordTemp(this.form.programmeDetailId);
      // 有历史生成记录就用历史的，没有就调用ai生成
      if (res.data.chatgptKeywordTempList.length > 0) {
        this.keywordList = res.data.chatgptKeywordTempList
      } else {
        await this.generateKeyword();
      }
    },
    // 关键词填充到方案
    async fillKeyword(keywordList) {
      let param = {
        automationId: this.automationId,
        automationContentId: this.form.automationContentId,
        keywordList: keywordList
      }
      await sem.aiAddProductKeyword(param);
      this.$message.success('填充到方案成功！')
    },
    // 规划师关键词添加到下面关键词列表
    addGoogleKey(item) {
      this.keywordList.unshift(item);
      // 关键词加入后，给加入的关键词请求图片。传入新加入的关键词在列表中的index即可；
      this.getKeywordImage(0)
    },
    // ai修改关键词
    async aiModify(text) {
      let param = {
        optimizeContent: text,
        programmeDetailId: this.form.programmeDetailId,
        programmeId: this.currentInfo.programmeId,
        serviceId: this.currentInfo.serviceId || undefined,
        sourceType: 1
      }
      this.keywordLoading = true;
      let res = await sem.keywordAiUpdate(param);
      this.keywordLoading = false;
      this.keywordList = res.data;
      // 给每个关键词获取图片
      await this.getKeywordImage();
    },
    // 删除生成的关键词
    delKeyword(keyword) {
      this.keywordList = this.keywordList.filter(item => {
        return item.id !== keyword.id;
      })
    },
    // 清空关键词
    clearKeyword() {
      this.keywordList = [];
    },
    // 重新生成关键词
    remakeKeyword() {
      // 先修改产品信息
      this.editProductInfo();
      // 调用生成关键词
      this.generateKeyword()
    },
    // 生成关键词接口
    async generateKeyword() {
      this.keywordLoading = true;
      this.keywordList = [];
      let param = {
        programmeId: this.currentInfo.programmeId,
        programmeDetailId: this.form.programmeDetailId,
        serviceId: this.currentInfo.serviceId || undefined
      };
      try {
        let res = await sem.aiKeyword(param)
        this.keywordLoading = false;
        this.keywordList = res.data;
        // 给每个关键词获取图片
        await this.getKeywordImage();
      } catch (e) {
        this.keywordLoading = false;
        this.keywordList = [];
      }
    },
    // 获取单个关键词图片
    async getKeywordImage(index) {
      if (typeof index === 'number') {
        let res = await sem.getKeywordImage(this.keywordList[index].id);
        this.keywordList[index].imageList = res.data;
      } else {
        // for (const item of this.keywordList) {
        //   let res = await sem.getKeywordImage(item.id);
        //   item.imageList = res.data
        // }
        this.keywordList.forEach(item => {
          sem.getKeywordImage(item.id).then(res => {
            item.imageList = res.data
          })
        })
      }

      // let _index = index;
      // console.log('开始请求', _index);
      // try {
      //
      //   let res = await sem.getKeywordImage(this.keywordList[_index].id);
      //   this.keywordList[_index].imageList = res.data;
      //   console.log(_index, '请求完成', this.keywordList)
      //   if (_index < this.keywordList.length - 1) {
      //     _index++;
      //     console.log('自增结束', _index)
      //     await this.getKeywordImage(_index);
      //   } else {
      //     console.log('总任务结束')
      //   }
      // } catch (e) {
      //   this.$message.error(this.productList[_index].content + '图片请求失败')
      //   _index++;
      //   await this.getKeywordImage(_index);
      // }
    },
    /**
     * 广告标题处理 --- 开始
     */
    // 请求标题生成记录
    async getAdsTitleTemp() {
      let res = await sem.getAdsTitleTemp(this.form.programmeDetailId);
      // 有历史生成记录就用历史的，没有就调用ai生成
      if (res.data.length > 0) {
        this.titleList = res.data
      } else {
        await this.adsTitle();
      }
    },
    // 标题填充到方案
    async fillTitle(list) {
      let param = {
        automationId: this.automationId,
        automationContentId: this.form.automationContentId,
        titleList: list,
        dataType: 1
      }
      await sem.aiAddProductTitle(param);
      this.$message.success('填充到方案成功！')
    },
    // ai修改标题
    async aiModifyTitle(text) {
      let param = {
        optimizeContent: text,
        programmeDetailId: this.form.programmeDetailId,
        programmeId: this.currentInfo.programmeId,
        serviceId: this.currentInfo.serviceId || undefined,
        sourceType: 2
      }
      this.titleLoading = true;
      try {
        let res = await sem.titleAiUpdate(param);
        this.titleLoading = false;
        this.titleList = res.data;
      } catch (e) {
        this.titleLoading = false;
        this.titleList = [];
      }
    },
    // 重新生成标题
    remakeTitle() {
      // 先修改产品信息
      this.editProductInfo();
      // 调用生成标题
      this.adsTitle()
    },
    // 单条删除广告标题
    delTitle(title) {
      this.titleList = this.titleList.filter(item => {
        return item.id !== title.id;
      })
    },
    // 清空广告标题
    clearTitle() {
      this.titleList = [];
    },
    // 生成广告标题
    async adsTitle() {
      this.titleLoading = true;
      this.titleList = [];
      let param = {
        programmeId: this.currentInfo.programmeId,
        programmeDetailId: this.form.programmeDetailId,
        serviceId: this.currentInfo.serviceId || undefined
      }
      try {
        let res = await sem.adsTitle(param)
        this.titleLoading = false;
        this.titleList = res.data;
      } catch (e) {
        this.titleLoading = false;
        this.titleList = [];
      }
    },

    /**
     * 广告描述处理 --- 开始
     */
    // 请求描述生成记录
    async getAdsIllustrateTemp() {
      let res = await sem.getAdsIllustrateTemp(this.form.programmeDetailId);
      // 有历史生成记录就用历史的，没有就调用ai生成
      if (res.data.length > 0) {
        this.descList = res.data
      } else {
        await this.adsDesc();
      }
    },
    // 描述填充到方案
    async fillDesc(list) {
      let param = {
        automationId: this.automationId,
        automationContentId: this.form.automationContentId,
        titleList: list,
        dataType: 2
      }
      await sem.aiAddProductTitle(param);
      this.$message.success('填充到方案成功！')
    },
    // ai修改描述
    async aiModifyDesc(text) {
      let param = {
        optimizeContent: text,
        programmeDetailId: this.form.programmeDetailId,
        programmeId: this.currentInfo.programmeId,
        serviceId: this.currentInfo.serviceId || undefined,
        sourceType: 2
      }
      this.descLoading = true;
      try {
        let res = await sem.illustrateAiUpdate(param);
        this.descLoading = false;
        this.descList = res.data;
      } catch (e) {
        this.descLoading = false;
        this.descList = [];
      }
    },
    // 重新生成描述
    remakeDesc() {
      // 先修改产品信息
      this.editProductInfo();
      // 调用生成描述
      this.adsDesc()
    },
    // 单条删除广告描述
    delDesc(desc) {
      this.descList = this.descList.filter(item => {
        return item.id !== desc.id;
      })
    },
    // 清空广告描述
    clearDesc() {
      this.descList = [];
    },
    // 生成广告描述
    async adsDesc() {
      this.descLoading = true;
      this.descList = [];
      let param = {
        programmeId: this.currentInfo.programmeId,
        programmeDetailId: this.form.programmeDetailId,
        serviceId: this.currentInfo.serviceId || undefined
      }
      try {
        let res = await sem.adsIllustrate(param)
        this.descLoading = false;
        this.descList = res.data;
      } catch (e) {
        this.descLoading = false;
        this.descList = [];
      }
    },

    /**
     * 广告描述处理 --- 结束
     */
    // 选择产品
    tagClick(product) {
      this.form = product;
      // 切换产品时，将关键词输入框清空
      this.aiKeyword = '';
      // 如果产品有关键词，则置入
      if (product.aiKeywordList.length) {
        this.aiKeyword = product.aiKeywordList.join('\n')
      }
      // 根据产品内包含哪些模块，请求对应的模块信息
      if (this.form.aiKeywordFlag) {
        this.getKeywordTemp()
        // this.generateKeyword();
      }
      if (this.form.aiTitleFlag) {
        // this.adsTitle();
        this.getAdsTitleTemp()
      }
      if (this.form.aiDescFlag) {
        this.getAdsIllustrateTemp();
        // this.adsDesc();
      }
    },
    // 请求产品信息
    async getProductList(param) {
      this.productLoading = true;
      try {
        let res = await sem.productInfo(param);
        this.productList = res.data.productList;
        this.productTypeList = res.data.productTypeList;
        this.productLoading = false;
        // 新户上线模式下，存一下自动化主ID，填充到方案功能用得到
        if (this.aiModel === 2) {
          this.automationId = res.data.automationId;
        }
        // 默认选中第一个
        if (this.productList.length > 0) {
          this.tagClick(this.productList[0])
        } else if (this.productTypeList.length > 0) {
          this.tagClick(this.productTypeList[0])
        }
      } catch (e) {
        this.productLoading = false;
      }
    },
    // 请求语言列表
    async adLanguage() {
      let res = await adsNewOnlineSer.adLanguage();
      this.languageList = res.data;
    },
    // 请求高级信息
    async getMontageContent(ruleType) {
      let res = await adsNewOnlineSer.getmontagecontent({
        ruleType
      })
      this.extraData = res.data;
    },
  }
}
</script>
<style lang="scss">
.thirdPage {
  .tagBox {
    .el-tag {
      margin-right: 20px;
      cursor: pointer;
    }
  }

  .formBox {
    border: 1px solid #999;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 0 10px;
    margin-top: 10px;

    .el-form-item__label {
      padding: 0;
    }
  }
}
</style>